import nativeProxy from '@nativeApp/nativeProxy';

// 初始化 app 切换到后台时的默认调用
const initBackDefaultFN = () => {
  nativeProxy.inject({
    name: 'wAppWillEnterBackground',
    func: () => {},
  });
  nativeProxy.inject({
    name: 'wAppBackgroundState',
    func: () => {},
  });
  nativeProxy.inject({
    name: 'wToggleScreenDirection',
    func: () => {},
  });
  nativeProxy.inject({
    name: 'wAppBeInterrupted',
    func: () => {},
  });
};

export const defineNativeDefault = () => {
  initBackDefaultFN();
};
